

export const EVENTS = {
  CHAT: {
    INIT: 'chat.init',
    INIT_SUCCESS: 'chat.init_success',
    INIT_ERROR: 'chat.init_error',
    OPEN_WITH_ADMIN: 'chat.open_with_admin',
    OPEN_CONVERSATION: 'chat.open_conversation',
    CLOSE: 'chat.close',
    TOGGLE: 'chat.toggle',
    MESSAGE_SENT: 'chat.message_sent',
    MESSAGE_RECEIVED: 'chat.message_received'
  }
};

export const CHAT_CONFIG = {

  adminUserId: 'admin-1'
};

export const CHAT_STATUS = {
  NOT_INITIALIZED: 'not_initialized',
  INITIALIZING: 'initializing',
  INITIALIZED: 'initialized',
  ERROR: 'error'
};
